import React from 'react';
import classNames from 'classnames';
import queryString from 'query-string';
import { Link } from 'react-router-dom';
import './table.scss';

const isDesc = (qs, param) => {    

    if (qs.orderby && qs.orderby.indexOf(param) > -1) {
        if (qs.orderby.indexOf('desc') > -1) {
            return true
        } else {
            return false
        }
    }

    return false;
}


const isSorting = (qs, param) => {    

    if (qs.orderby && qs.orderby.indexOf(param) > -1) {
        return true;
    }

    return false;
}

const getSorting = (order, param) => {    

    if (order && order.indexOf(param) > -1) {
        if (order.indexOf('desc') > -1) {
            return `${param} asc`;
        } else {
            return `${param} desc`;
        }
    }

    return `${param} asc`;
}

const getSortParams = (qs, param) => {
    const query = {...qs};
    query.orderby = getSorting(query.orderby, param);

    return `?${queryString.stringify(query)}`;
}

const Table = props => {

    const { location } = props;
    const qs = queryString.parse(location.search);
    qs.page = 1;

    return (
        <table className="search-table">
            <tbody>
                <tr>
                    <th>
                        <Link to={getSortParams(qs, 'unitname')} className={classNames({
                            'search-table__sorter': true,
                            'search-table__sorter--is-sorting': isSorting(qs, 'unitname'),
                            'search-table__sorter--is-desc': isDesc(qs, 'unitname')
                        })}>ENHET</Link>
                    </th>
                    <th>
                        <Link to={getSortParams(qs, 'unitid')} className={classNames({
                            'search-table__sorter': true,
                            'search-table__sorter--is-sorting': isSorting(qs, 'unitid'),
                            'search-table__sorter--is-desc': isDesc(qs, 'unitid')
                        })}>DELFI-ID</Link>
                    </th>
                    <th><Link to={getSortParams(qs, 'typename')} className={classNames({
                            'search-table__sorter': true,
                            'search-table__sorter--is-sorting': isSorting(qs, 'typename'),
                            'search-table__sorter--is-desc': isDesc(qs, 'typename')
                        })}>TYP</Link></th>
                    <th><Link to={getSortParams(qs, 'address')} className={classNames({
                            'search-table__sorter': true,
                            'search-table__sorter--is-sorting': isSorting(qs, 'address'),
                            'search-table__sorter--is-desc': isDesc(qs, 'address')
                        })}>ADRESS</Link></th>
                    <th><Link to={getSortParams(qs, 'city')} className={classNames({
                            'search-table__sorter': true,
                            'search-table__sorter--is-sorting': isSorting(qs, 'city'),
                            'search-table__sorter--is-desc': isDesc(qs, 'city')
                        })}>ORT</Link></th>
                    <th><Link to={getSortParams(qs, 'turnover')} className={classNames({
                            'search-table__sorter': true,
                            'search-table__sorter--is-sorting': isSorting(qs, 'turnover'),
                            'search-table__sorter--is-desc': isDesc(qs, 'turnover')
                        })}>OMSÄTTNING <span className="table__light-header">(KKR)</span></Link></th>
                    <th><Link to={getSortParams(qs, 'retailarea')} className={classNames({
                            'search-table__sorter': true,
                            'search-table__sorter--is-sorting': isSorting(qs, 'retailarea'),
                            'search-table__sorter--is-desc': isDesc(qs, 'retailarea')
                        })}>SÄLJYTA <span className="table__light-header">(m2)</span></Link></th>
                    <th><Link to={getSortParams(qs, 'chainname')} className={classNames({
                            'search-table__sorter': true,
                            'search-table__sorter--is-sorting': isSorting(qs, 'chainname'),
                            'search-table__sorter--is-desc': isDesc(qs, 'chainname')
                        })}>KEDJA</Link></th>
                    <th><Link to={getSortParams(qs, 'telephone')} className={classNames({
                            'search-table__sorter': true,
                            'search-table__sorter--is-sorting': isSorting(qs, 'telephone'),
                            'search-table__sorter--is-desc': isDesc(qs, 'telephone')
                        })}>TEL</Link></th>
                </tr>
                {props.result && props.result.map((item, i) => {

                    return (
                        <tr key={`search-table${i}`}>
                            <td>
                                <Link to={{
                                    pathname:`/unit/${item.DelfiId}`,
                                    state: { from: props.location } 
                                }}>{item.UnitName}</Link>
                            </td>
                            <td>
                                {item.DelfiId}
                            </td>
                            <td>
                                {item.TypeName}
                            </td>
                            <td>
                                {item.VisitingAddress.Address}
                            </td>
                            <td>
                                {item.VisitingAddress.City}
                            </td>
                            <td>
                                {(item.Turnover*1).toLocaleString('sv')}   
                            </td>
                            <td>
                                {(item.RetailArea*1).toLocaleString('sv')}   
                            </td>
                            <td>
                                {item.ChainName}   
                            </td>
                            <td>
                                {item.Telephone}   
                            </td>
                        </tr>
                    );    
                })}
            </tbody>
        </table>
    );
};

export default Table;